export default __webpack_public_path__ + "2024 Efficient generation of polarization-entangled photons in metal-organic framework waveguides.pdf";